import { createFileRoute, notFound } from '@tanstack/react-router';

type SearchParams = {
  draftSort?: 'DESC' | 'ASC';
};

// Define the allowed filter values as a union type
type FilterParam = 'inbox' | 'archived' | 'drafts' | 'scheduled' | 'blocked';

// Helper function to validate the filter parameter
const isValidFilter = (filter: string): filter is FilterParam => {
  return ['inbox', 'archived', 'drafts', 'scheduled', 'blocked'].includes(filter);
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/messages/$filter')({
  params: {
    parse: (params) => {
      // Validate the filter parameter
      if (!isValidFilter(params.filter)) {
        throw notFound();
      }
      return {
        ...params,
        filter: params.filter,
      };
    },
  },
  beforeLoad: ({ params }) => {
    // Validate the filter parameter
    if (!isValidFilter(params.filter)) {
      throw notFound();
    }

    // Return validated params for use in the component
    return {
      validatedFilter: params.filter,
    };
  },

  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    // TODO: validate any of these search params validity
    return search;
  },
});
